import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=2fa69cac"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"
import style0 from "./Section2.vue?vue&type=style&index=0&id=2fa69cac&prod&lang=css"
import style1 from "./Section2.vue?vue&type=style&index=1&id=2fa69cac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports